module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 offset-sm-4"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "fromlocation"
    }
  }, [_vm._v("From Location")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.fromlocation),
      expression: "quote.fromlocation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "fromlocation",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.quote.fromlocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "fromlocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "tolocation"
    }
  }, [_vm._v("To Location")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.tolocation),
      expression: "quote.tolocation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "tolocation",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.quote.tolocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "tolocation", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "shipickupdate"
    }
  }, [_vm._v("Pick up")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipickupdate),
      expression: "shipickupdate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validDate'),
      expression: "'required|validDate'"
    }],
    staticClass: "form-control datetimepicker",
    attrs: {
      "type": "text",
      "id": "shipickupdate",
      "name": "pick up"
    },
    domProps: {
      "value": (_vm.shipickupdate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipickupdate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "condeliverydate"
    }
  }, [_vm._v("Delivery")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condeliverydate),
      expression: "condeliverydate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validDate'),
      expression: "'required|validDate'"
    }],
    staticClass: "form-control datetimepicker",
    attrs: {
      "type": "text",
      "id": "condeliverydate",
      "name": "delivery"
    },
    domProps: {
      "value": (_vm.condeliverydate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.condeliverydate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "transittime"
    }
  }, [_vm._v("Transit Time")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.transittime),
      expression: "quote.transittime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "transittime"
    },
    domProps: {
      "value": (_vm.quote.transittime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "transittime", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "basecharge"
    }
  }, [_vm._v("Base Charge")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.basecharge),
      expression: "quote.basecharge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "basecharge"
    },
    domProps: {
      "value": (_vm.quote.basecharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "basecharge", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "fuelcharge"
    }
  }, [_vm._v("Fuel Charge")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.fuelcharge),
      expression: "quote.fuelcharge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "fuelcharge"
    },
    domProps: {
      "value": (_vm.quote.fuelcharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "fuelcharge", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bordercharge"
    }
  }, [_vm._v("Border Charge")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.bordercharge),
      expression: "quote.bordercharge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "bordercharge"
    },
    domProps: {
      "value": (_vm.quote.bordercharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "bordercharge", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "handlingcharge"
    }
  }, [_vm._v("Handling Charge")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.handlingcharge),
      expression: "quote.handlingcharge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "handlingcharge"
    },
    domProps: {
      "value": (_vm.quote.handlingcharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "handlingcharge", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "additionalcharge"
    }
  }, [_vm._v("Additional Charges")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.additionalcharge),
      expression: "quote.additionalcharge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "additionalcharge"
    },
    domProps: {
      "value": (_vm.quote.additionalcharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "additionalcharge", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "quotenumber"
    }
  }, [_vm._v("Quote Number")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.quotenumber),
      expression: "quote.quotenumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "quotenumber"
    },
    domProps: {
      "value": (_vm.quote.quotenumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "quotenumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._l((_vm.errors.all()), function(error) {
    return _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    staticClass: "btn btn-primary quoteButton",
    attrs: {
      "id": "statusbutton"
    },
    on: {
      "click": _vm.beforeFinishQuote
    }
  }, [_vm._v("Submit Quote")])])], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Finish Quote")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6afcab34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/rfq/finish.vue
// module id = 727
// module chunks = 0